import { BaseContainerModel } from "../base-container.model";
import { bl_applet_edition_pricing_hdr_RowClass } from '../../dbschema'

export class AppletEditionPricingContainerModel extends BaseContainerModel {
    bl_applet_edition_pricing_hdr = new bl_applet_edition_pricing_hdr_RowClass();
}